module.exports = __webpack_public_path__ + "img/ic_24_team_triathlon.936bc025.svg";